import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { ApiService, BaseApiService } from '@fc-core/services/base-api.service';
import { MaintenanceSchedule } from '@fc-core/models';
import { expand, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { MaintenanceAlertApiService } from './maintenance-alert-api.service';

@Injectable({ providedIn: 'root' })
@ApiService({})
export class MaintenanceScheduleApiService extends BaseApiService {
  constructor(private http: HttpClient) {
    super();
  }

  static fromJSON(res: any): MaintenanceSchedule {
    res.alert = MaintenanceAlertApiService.fromJSON(res.alert || {});
    return res;
  }

  // TODO: replace hand-rolled pagination loop with fetchAllPages (@fc-shared/utils/request-utils/fetch-all-pages)
  loadAll(vehicleId: number): Observable<MaintenanceSchedule[]> {
    return this.http.get(this.getVehicleUrl(vehicleId)).pipe(
      expand((results: any) => {
        if (!!results['next']) {
          return this.http.get(results['next']);
        } else {
          return EMPTY;
        }
      }),
      map((res: any) => res['results']),
      map((res): MaintenanceSchedule[] => {
        return res.map((schedule: any) =>
          MaintenanceScheduleApiService.fromJSON(schedule),
        );
      }),
    );
  }

  maintenanceUpdate(
    schedule: MaintenanceSchedule,
  ): Observable<MaintenanceSchedule> {
    return this.http
      .put(this.getScheduleUrl(schedule.vehicle, schedule), schedule)
      .pipe(map(MaintenanceScheduleApiService.fromJSON));
  }

  create(schedule: MaintenanceSchedule): Observable<MaintenanceSchedule> {
    return this.http
      .post(this.getVehicleUrl(schedule.vehicle), schedule)
      .pipe(map(MaintenanceScheduleApiService.fromJSON));
  }

  delete(schedule: MaintenanceSchedule): Observable<MaintenanceSchedule> {
    return this.http
      .delete(this.getScheduleUrl(schedule.vehicle, schedule))
      .pipe(map(() => schedule));
  }

  protected getVehicleUrl(vehicleId: number): string {
    return `${this.getBaseUrl()}/maintenance/vehicle/${vehicleId}/schedule/`;
  }

  protected getScheduleUrl(
    vehicleId: number,
    schedule: MaintenanceSchedule,
  ): string {
    return `${this.getBaseUrl()}/maintenance/vehicle/${vehicleId}/schedule/${
      schedule.id
    }/`;
  }
}
